export const COD_ANAF_NEGASIT = "anaf_negasit";
export const COD_ANAF_INDISPONIBIL = "anaf_indisponibil";
export const COD_CAEN_PRINCIPAL_LIPSA = "caen_principal_lipsa";

export type CodEroareIdentificare =
  | typeof COD_ANAF_NEGASIT
  | typeof COD_ANAF_INDISPONIBIL;

export type SursaIdentificare = "anaf_live" | "anaf_cache" | "onrc_local";

export type SursaDate =
  | SursaIdentificare
  | "onrc"
  | "mf"
  | "mf_ir"
  | "mf_ic"
  | "termene"
  | "productie_2024"
  | "infocui"
  | "manual"
  | "fara_bilant";

export type IdentificareFirma = {
  cui: string;
  denumire: string | null;
  cod_inmatriculare: string | null;
  euid: string | null;
  forma_juridica: string | null;
  caen_principal: string | null;
  adresa: string | null;
  judet: string | null;
  localitate: string | null;
  cod_postal: string | null;
  telefon: string | null;
  fax: string | null;
  web: string | null;
  tva: boolean | null;
  tva_de_la: string | null;
  stare_inregistrare: string | null;
  activa: boolean | null;
  data_actualizare: string | null;
  snapshot: string | null;
  verificat_onrc: boolean | null;
};

export type RezultatIdentificare =
  | {
      stare: "gasit";
      firma: IdentificareFirma;
      sursa: SursaIdentificare;
      la: string;
      raw: unknown | null;
    }
  | { stare: "negasit" }
  | { stare: "indisponibil"; motiv: string };

export type SurseDateIdentificare = {
  sursa: SursaDate;
  la: string | null;
  snapshot: string | null;
};

export type SurseDateCaen = {
  sursa: SursaDate;
  snapshot: string | null;
};

export type SurseDateBilant = {
  an: number | null;
  sursa: SursaDate;
  publicat: string | null;
};

export type SurseDateListe = {
  versiune: string | null;
};

export type SurseDate = {
  identificare?: SurseDateIdentificare;
  caen?: SurseDateCaen;
  bilant?: SurseDateBilant;
  liste?: SurseDateListe;
};

export type AnBilant = {
  an: number;
  sursa: SursaDate;
  publicat_la: string | null;
  caen_declarat: string | null;
  caen_ver: number | null;
  salariati: number | null;
  cifra_afaceri: number | null;
  active_imobilizate: number | null;
  active_circulante: number | null;
  active_totale: number | null;
  curs: { an: number; curs: number; data: string; sursa: string } | null;
};

export type RaspunsBilant = {
  ani: AnBilant[];
  an_recomandat: number | null;
  sursa: SursaDate;
};

export type VersiuneCaen = "2" | "3";

export type CodCaenAutorizat = {
  ver: VersiuneCaen;
  cod: string;
  principal: boolean;
  sursa: string;
};

export type RaspunsSucursaleUe = {
  cui: string;
  sucursale: Array<{
    tara: string | null;
    denumire: string | null;
    euid: string | null;
  }>;
  snapshot: string | null;
};
